export const isLoading = (state) => state.loading

export const isDirty = (state) => state.data != null && state.data._dirty === true

export const getSchema = (state) => state.schema

export const getResourceType = (state) => {
  if (state.schema != null) {
    return state.schema.route
  } else {
    return null
  }
}

export const getData = (state) => state.data



// WEBPACK FOOTER //
// ./src/store/modules/creator/getters.js